
import Coupon from "../../../Components/Cards/Coupon/Coupon";
import FilterColorful from "../../../Components/Buttons/FilterColorful";
import FilterOverflowRow from "../../../Components/Buttons/FilterOverflowRow";
import { useState, useEffect } from "react";
import { isoToJalali } from "../../../helper/isoToJalali";
import { useNavigate } from "react-router-dom";
import SVG from "../../../Components/SVG";
import { API_BASE_URL } from "../../../config/api";

export default function CardsGeneral() {
  const navigate = useNavigate();
  const [coupon, setCoupon] = useState(null);
  const [accLoading, setAccLoading] = useState(true);
  const fetchCouponData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}challenges/trader/coupons/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}challenges/trader/coupons/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setCoupon(data);
      setAccLoading(false);
    } catch (error) {
      console.error("Error fetching account data:", error);
      setAccLoading(false);
    }
  };
  useEffect(() => {
    fetchCouponData();
  }, []);
  // useEffect(() => {
  //   if (
  //     coupon &&
  //     coupon.for_all.used.length === 0 &&
  //     coupon.for_all.active.length === 0
  //   ) {
  //     setAccLoading(false);
  //   }
  // }, [coupon]);
  const [activeFilter, setActiveFilter] = useState([true, true]);
  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <FilterOverflowRow>
        <FilterColorful
          SVGName="tick"
          text="فعال"
          className="w-[104px] shrink-0"
          color={activeFilter[0] ? "green" : "gray"}
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          filterIndex={0}
        />
        <FilterColorful
          SVGName="star"
          text="استفاده شده"
          className="w-[104px] shrink-0"
          color={activeFilter[1] ? "blue" : "gray"}
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          filterIndex={1}
        />
      </FilterOverflowRow>

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 justify-items-center gap-x-10 gap-y-20 relative min-h-[191.44px]">
        {coupon &&
          activeFilter[0] &&
          coupon.for_all.active.map((item) => (
            <Coupon
              accLoading={accLoading}
              setAccLoading={setAccLoading}
              color="green"
              code={item.name}
              title={`کد تخفیف ${Number(item.discount_percent).toFixed(
                0,
              )} درصدی`}
              challenge={
                item.is_for_all_challenges
                  ? `برای همه چالش ها`
                  : item.challenge_category
                    ? `مخصوص دسته ${item.challenge_category}`
                    : `مخصوص چالش ${item.challenge_name}`
              }
              expiration={`معتبر تا ${isoToJalali(item.expired_at)}`}
            />
          ))}
        {coupon &&
          activeFilter[1] &&
          coupon.for_all.used.map((item) => (
            <Coupon
              color="blue"
              accLoading={accLoading}
              setAccLoading={setAccLoading}
              code={item.name}
              title={`کد تخفیف ${Number(item.discount_percent).toFixed(
                0,
              )} درصدی`}
              challenge={
                item.is_for_all_challenges
                  ? `برای همه چالش ها`
                  : item.challenge_category
                    ? `مخصوص دسته ${item.challenge_category}`
                    : `مخصوص چالش ${item.challenge_name}`
              }
              expiration={`معتبر تا ${isoToJalali(item.expired_at)}`}
            />
          ))}
        {accLoading && (
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 justify-items-center gap-x-10 gap-y-20 absolute top-[0px]">
            <div className="w-full max-w-96">
              <div className="w-full aspect-[343/171] rounded-2xl skeleton"></div>
            </div>
            <div className="w-full max-w-96">
              <div className="w-full aspect-[343/171] rounded-2xl skeleton"></div>
            </div>
          </div>
        )}
        {coupon &&
          coupon.for_all.used.length === 0 &&
          coupon.for_all.active.length === 0 && (
            <div className="w-full flex justify-center items-center flex-col gap-5 absolute top-0 left-0">
              <p className="text-zi-text-light dark:text-zi-text-dark text-sm sm:text-base">
                موردی برای نمایش وجود ندارد
              </p>
              <SVG name="noData" classname="w-24 fill-cyan-500" />
            </div>
          )}
      </div>
    </div>
  );
}
